export default __webpack_public_path__ + "static/media/blue_slider.7f3d88a1.svg";